<template>
  <a-modal
    v-model:visible="visible"
    :title="modalTitle"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form
      :model="formData"
      :label-col-props="{ span: 6 }"
      :wrapper-col-props="{ span: 18 }"
      label-align="left"
    >
      <a-form-item field="result_level" :label="$t('form.result_level')">
        <a-select
          v-model="formData.result_level"
          :placeholder="$t('form.result_level.placeholder')"
          :filter-option="false"
          allow-clear
        >
          <a-option value="1">有效一级</a-option>
          <a-option value="2">有效二级</a-option>
          <a-option value="3">有效三级</a-option>
          <a-option value="-1">无效一级</a-option>
          <a-option value="-2">无效二级</a-option>
        </a-select>
      </a-form-item>
      <a-form-item field="content" :label="$t('form.follow_up_content')">
        <a-input
          v-model="formData.content"
          :placeholder="$t('form.follow_up_content.placeholder')"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts" setup>
  import { ref, computed, watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import type { FollowUpRecordData, FollowUpRecordModalProps } from './types';

  type Props = FollowUpRecordModalProps;

  interface Emits {
    (e: 'update:visible', value: boolean): void;
    (e: 'submit', data: FollowUpRecordData): void;
    (e: 'cancel'): void;
  }

  const props = withDefaults(defineProps<Props>(), {
    mode: 'add',
    record: () => ({
      user_id: 0,
      result_level: '',
      content: '',
      reminder_id: 0,
    }),
  });

  const emit = defineEmits<Emits>();

  const { t } = useI18n();

  const formData = ref<FollowUpRecordData>({
    user_id: 0,
    result_level: '',
    content: '',
    reminder_id: 0,
  });

  const modalTitle = computed(() => {
    return props.mode === 'edit' ? '编辑回访记录' : '添加回访记录';
  });

  const visible = computed({
    get: () => props.visible,
    set: (value: boolean) => emit('update:visible', value),
  });

  // 监听record变化，更新表单数据
  watch(
    () => props.record,
    (newRecord) => {
      if (newRecord) {
        formData.value = {
          // id: newRecord.id,
          user_id: newRecord.user_id,
          result_level: newRecord.result_level,
          content: newRecord.content,
          reminder_id: newRecord.reminder_id,
        };
      }
    },
    { immediate: true, deep: true }
  );

  // 监听mode变化，重置表单
  watch(
    () => props.mode,
    () => {
      if (props.mode === 'add') {
        formData.value = {
          user_id: 0,
          result_level: '',
          content: '',
          reminder_id: 0,
        };
      }
    }
  );

  const handleSubmit = () => {
    emit('submit', { ...formData.value });
  };

  const handleCancel = () => {
    emit('cancel');
  };
</script>

<script lang="ts">
  export default {
    name: 'FollowUpRecordModal',
  };
</script>
